import { useEffect, useState } from "react"

import { DynamicFormTemplate } from "../../utilities"

const QuestionnaireForm = (props) => {
    const {
        isHidden,
        formData,
        error
    } = props

    const ignoreObject = {
        "_parametres_": true,
        "Matériel": true,
        "Exploitant": true,
        "options de relance": true,
        "Conclusion du contrôle": true,
        "copies et enregistrement": true
    }
    const [formElements, setFormElements] = useState([])
    const [errorInput, setErrorInput] = useState({})

    const generateForm = () => {
        const form = []
        const formKey = Object.keys(formData)
        formKey.forEach(key => {
            if (!ignoreObject[key]) {
                const elementKey = Object.keys(formData[key])
                const elements = []
                elementKey.forEach(k => {
                    const element = formData[key][k]

                    let isAutoComplete = false
                    if (element.typehtml === "text") {
                        isAutoComplete = element.liste_valeurs && element.liste_valeurs.length > 0
                    }
                    if (isAutoComplete) {
                        const options = element.liste_valeurs.split(";").map(el => ({label: el, id: el}))
                        element.typehtml = "autocomplete"
                        element.options = options
                        element.allowFreeText = true
                        element.displayAllOption = true
                    }

                    elements.push(element)
                })

                elements.sort((a, b) => parseInt(a.position) - parseInt(b.position))
                form.push({ key, elements })
            }
        })

        setFormElements(form)
    }

    useEffect(() => {
        if (error.length > 0) {
            let errorInputTemp = {}
            error.forEach(e => {
                errorInputTemp = { ...errorInputTemp, [e]: true }
            })
            setErrorInput(errorInputTemp)
            generateForm()
        }
    }, [error])

    useEffect(() => {
        generateForm()
    }, [])

    return <div style={{ display: isHidden ? "none" : "block" }}>
        {formElements.length > 0 ? formElements.map(ele => (<div key={ele.key} className="form-container">
            <p className="bold form-group">{ele.key}</p>
            <DynamicFormTemplate isHidden={false} formData={ele.elements} defaultValue={{}} error={errorInput} />
        </div>)) : null}
    </div>
}

export default QuestionnaireForm;